import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./entitydashboard.scss";
// import companylogo from "../../../assets/company-logo.svg";
import { fetchEntityDetail } from "../globalEntitiesSlice";
import { Skeleton } from "primereact/skeleton";
const CompanyInfoCard = ({ childEntitiesData, accountManager }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      dispatch(fetchEntityDetail(id))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }, 2000);
    return () => clearTimeout(timeout);
  }, [dispatch, id]);
  return (
    <div className="info-main-container">
      {/* <div className="logo-container">
    <img src={companylogo} alt="company-logo" />
  </div> */}
      <div className="details-container">
        <div className="company-name">
          <h2>
            {!loading ? childEntitiesData?.name : <Skeleton className="p-3" />}
          </h2>
        </div>
        <div className="company-details">
          <div className="item-detail">
            <p className="item-name">Type:</p>
            <p className="item-value">
              {!loading ? (
                childEntitiesData?.type
              ) : (
                <Skeleton className="p-2" />
              )}
            </p>
          </div>
          <span className="border-bracket"></span>
          <div className="item-detail">
            <p className="item-name">Country:</p>
            <p className="item-value">
              <ReactCountryFlag
                className="mr-2"
                countryCode={
                  !loading ? childEntitiesData?.country || "" : <Skeleton />
                }
                svg
              />
              {!loading ? (
                getName(childEntitiesData?.country || "")
              ) : (
                <Skeleton />
              )}
            </p>
          </div>
          <span className="border-bracket"></span>
          {id !== childEntitiesData?.parentEntity &&
            childEntitiesData?.parentEntity && (
              <>
                <div className="item-detail">
                  <p className="item-name">Parent Entity:</p>
                  <Link
                    className="entity-link"
                    to={`/entity/${!loading ? childEntitiesData?.parentEntity?.id : <Skeleton />}/dashboard`}
                  >
                    <p className="item-value">
                      {!loading ? (
                        childEntitiesData?.parentEntity?.name
                      ) : (
                        <Skeleton />
                      )}
                    </p>
                  </Link>
                </div>
                <span className="border-bracket"></span>
              </>
            )}
          <div className="item-detail">
            <p className="item-name">Account Name:</p>
            <p className="item-value">
              {!loading ? childEntitiesData?.tenantData?.name : <Skeleton />}
            </p>
          </div>
          <span className="border-bracket"></span>
          <div className="item-detail">
            <p className="item-name">Account Manager:</p>
            {!loading ? (
              <p className="item-value">
                {(() => {
                  const accountManagerData =
                    childEntitiesData?.accountManagerData;
                  return accountManagerData
                    ? accountManagerData.preferred_name ||
                        [
                          accountManagerData.given_name,
                          accountManagerData.surname,
                        ]
                          .filter(Boolean)
                          .join(" ")
                    : childEntitiesData?.account_manager_name;
                })()}
              </p>
            ) : (
              <p className="item-value">
                <Skeleton />
              </p>
            )}
          </div>
          <span className="border-bracket"></span>
        </div>
      </div>
    </div>
  );
};
export default CompanyInfoCard;
